var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", { attrs: { subtitle: _vm.subTitle } }),
      _vm._v(" "),
      _vm.isLoading
        ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.hasData
        ? _c(
            "v-layout",
            { attrs: { elevation: "0", row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", "pa-1": "" } },
                [
                  _c("Subheader", { attrs: { title: "Metadata" } }),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    { attrs: { elevation: "0" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("KVStoreTable", {
                            attrs: { value: _vm.specimen.Metadata },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", "pa-1": "" } },
                [
                  _c("Subheader", { attrs: { title: "Surveys" } }),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    { attrs: { elevation: "0" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-list",
                            { attrs: { "three-line": "" } },
                            [
                              _vm._l(
                                _vm.specimen.Surveys,
                                function (survey, i) {
                                  return [
                                    i != 0
                                      ? _c("v-divider", {
                                          key: `divider-${survey.Id}`,
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("PlotSurveyHeader", {
                                      key: survey.ParentSurveyId,
                                      attrs: { value: survey },
                                    }),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.specimen.Surveys, function (survey) {
                return _c(
                  "v-flex",
                  { key: `survey-data-${survey.Id}`, attrs: { xs12: "" } },
                  [
                    _c("Subheader", {
                      attrs: {
                        title: `Specimen survey ${_vm.specimen.SpeciesCode} ${survey.SurveyDateTimeRaw}`,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "v-card",
                      { attrs: { elevation: "0" } },
                      [
                        _c(
                          "v-card-text",
                          [
                            _c("KVStoreTable", {
                              attrs: { value: survey.Metadata },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }